<template>
  <div class="layout-footer"></div>
</template>
<script>
export default {
  name: "Footer"
}
</script>
<style scoped>
</style>